import "./styles.scss";

import React, { useState } from "react";
import classnames from "classnames";

import Button from "../Button";

import { useApp } from "context/app";

import facilitiesParser from "utils/facilitiesParser";
import roomSuffixRender from "utils/roomSuffixRender";
import scrollToElement from "utils/scrollToElement";

import CPinIcon from "icons/facilities/c-pin.svg";
import MessageIcon from "icons/message.svg";
import StarIcon from "icons/star.svg";
import { Link } from "gatsby";

const mainClass = "investment_grid_item";

const LinkWrapper = ({ props }) => {
  const [is_touched, setIsTouched] = useState(false);

  let href;

  if (props?.investments?.ourHotels) {
    if (!!props?.investments?.ourHotelsLink) {
      href = props?.investments?.ourHotelsLink;
    }
  } else {
    href = props?.uri;
  }

  const clickHandler = (e) => {
    if (!!!is_touched) {
      e.preventDefault();
    }
    setIsTouched(true);
  };

  if (href) {
    return (
      <Link
        to={href}
        onClick={clickHandler}
        onMouseEnter={clickHandler}
        onMouseLeave={() => setIsTouched(false)}
      >
        <InvestmentGridItemContent {...props} />
      </Link>
    );
  } else {
    return <InvestmentGridItemContent {...props} />;
  }
};

const InvestmentGridItemContent = ({
  uri,
  title,
  investments,
  items,
  description,
  variant,
  popup_form,
}) => {
  const { setContactFormModal } = useApp();
  const facilities_items = facilitiesParser(investments)?.filter(
    (item) => item?.status === true
  );

  return (
    <div
      className={classnames(mainClass, {
        [`${mainClass}--${variant}`]: !!variant,
      })}
    >
      <div
        className={`${mainClass}__image`}
        style={{
          backgroundImage: `url(${
            investments?.ourHotelsPhoto?.sourceUrl ||
            investments?.mainImg?.sourceUrl
          })`,
        }}
      >
        {!!description && (
          <button className={`${mainClass}__image__fav-btn`}>
            <StarIcon />
          </button>
        )}
        {!!investments?.ready && (
          <div className={`${mainClass}__image__sold-out`}>
            <span>Inwestycja wyprzedana</span>
          </div>
        )}
        {investments?.labelState && (
          <div className={`${mainClass}__image__label`}>
            <span>{investments?.labelText}</span>
          </div>
        )}
      </div>
      <div className={`${mainClass}__content`}>
        <div className={`${mainClass}__content__title`}>
          <span>
            <CPinIcon />
            {investments?.shortLocation}
          </span>
          <h3
            dangerouslySetInnerHTML={{
              __html: investments?.mainTitle?.split("|")?.join("<br/>"),
            }}
          />
        </div>
        <div className={`${mainClass}__content__info`}>
          {!!investments?.ourHotels ? (
            <div className={`${mainClass}__content__info__rooms`}>
              <span>
                {investments?.ourHotelsRooms}{" "}
                <span>{roomSuffixRender(investments?.ourHotelsRooms)}</span>
              </span>
              <div className={`${mainClass}__content__info__rooms__facilities`}>
                <label>Udogodnienia:</label>

                <p>
                  {facilities_items?.map((item) => item?.label)?.join(", ")}
                </p>
              </div>
            </div>
          ) : !!description ? (
            <p>{investments?.subtitle}</p>
          ) : (
            items?.map(({ key, label, value, suffix }, index) => {
              if (!!!value) return;

              return (
                <div
                  className={classnames(`${mainClass}__content__info__item`, {
                    [`${mainClass}__content__info__item--hightlight-text`]:
                      key === "price",
                  })}
                  key={index}
                >
                  <label>{label}</label>
                  <span>
                    {value} {!!suffix && <span>{suffix}</span>}
                  </span>
                </div>
              );
            })
          )}
        </div>
        <div className={`${mainClass}__content__actions`}>
          {!!investments?.ourHotels ? (
            !!investments?.ourHotelsLink && (
              <a
                href={investments?.ourHotelsLink}
                target="_blank"
                rel="noreferrer"
                onClick={(e) => e.stopPropagation()}
              >
                <Button>Szczegóły...</Button>
              </a>
            )
          ) : (
            <Button href={uri}>Szczegóły...</Button>
          )}
          <Button
            icon={<MessageIcon />}
            variant="navy"
            onClick={
              !!popup_form
                ? (e) => {
                    e.preventDefault();
                    setContactFormModal({ investment: title });
                  }
                : () => scrollToElement("#contact-form")
            }
          >
            Zapytaj
          </Button>
        </div>
      </div>
    </div>
  );
};

const InvestmentGridItem = ({
  uri,
  title,
  investments,
  items,
  description,
  variant,
  popup_form,
}) =>
  LinkWrapper({
    props: {
      uri,
      title,
      investments,
      items,
      description,
      variant,
      popup_form,
    },
  });

export default InvestmentGridItem;
